<template>
  <v-form :ref="ref" :disabled="block || loading" autocomplete="off" lazy-validation class="ed-form">
    <div class="col-md-12 pa-2 justify-center text-center">
      <div class="row">
        <slot />
        <div class="col-md-12 pa-0 ma-0 text-center d-flex align-center flex-column">
          <vue-recaptcha
            v-if="recaptcha"
            style="width:304px !important"
            :sitekey="recaptchaKey"
            :key="recaptchaId"
            :loadRecaptchaScript="true"
            @verify="onRecaptchaVerify"
            @error="onRecaptchaError"
            @expired="onRecaptchaError"
            @render="onRecaptchaRender"
          />
        </div>
      </div>
    </div>

    <ed-alert type="warning" :message="blockMessage" v-if="block && blockMessage" />

    <div :class="'col-md-12 pa-0 justify-center '+classFooter">
      <ed-button
        v-if="handlerSave"
        :color="colorButton"
        :label="labelButton"
        :disabled="block || !isValidRecaptcha"
        @click="validar"
        :iconLeft="iconButton"
        size="100%"
      />
      <slot name="form-footer" />
    </div>
  </v-form>
</template>

<script>
import EdButton from "./EdButton";
import EdAlert from "./EdAlert";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "EdForm",
  mixins: [],
  components: { EdButton, EdAlert, VueRecaptcha },
  props: {
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
    reset: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    blockMessage: {
      type: String,
      required: false,
      default: null,
    },
    handlerSave: {
      type: Function,
      required: false,
      default: null,
    },
    labelButton: {
      type: String,
      required: false,
      default: "Salvar",
    },
    colorButton: {
      type: String,
      required: false,
      default: "primary",
    },
    iconButton: {
      type: String,
      required: false,
      default: "fa fa-floppy-o",
    },
    classFooter: {
      type: String,
      default: "text-right",
    },
    recaptcha: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      ref: "form-" + this.$utilidade.randomString(),
      recaptchaKey: process.env.GOOGLE_RECAPTCHA,
      recaptchaId:1,
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {
    isValidRecaptcha(){

      if(!this.recaptcha)return true;

      return (this.formData && this.formData.recaptcha);
    }
  },
  methods: {
    validar() {

      if(!this.isValidRecaptcha){
        this.$root.$dialog.alert("Por favor informe se você não é um robô");
        return;
      }

      if (!this.$refs[this.ref].validate()) {
        this.$root.$dialog.alert("Por favor preencher todos os campos");
        return;
      }

      if (this.handlerSave) {
        this.handlerSave();
      }
    },

    resetValidation(){
      this.$refs[this.ref].resetValidation()
    },

    onRecaptchaVerify(ev){
      this.$emit('recaptcha',ev);
    }, 

    onRecaptchaError(ev){
      this.$emit('recaptcha',null);
    },

    onRecaptchaRender(id){
    }
  },
  watch: {
    block() {},
    loading(){},
    blockMessage() {},
    recaptchaResponse(){
    },
    reset(){
      this.resetValidation()
    },
    'formData.recaptcha'(){},
    '$root.$request.getResponse'(){
      let response = this.$root.$request.getResponse

      if(response && response.status == 503){
        this.recaptchaId++;
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/template/EdForm.vue